'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _actions = require('../../utils/actions');

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var inViewportWatcher = void 0; /** @jsx dom */


var getClasses = function getClasses(props) {
	var classes = {
		'Grid-cell': true
	};

	['size', 'md-size', 'lg-size', 'u-sm-flexOrder', 'u-md-flexOrder', 'u-lg-flexOrder'].forEach(function (x) {
		if (/^\d+of\d+$/.test(props[x])) {
			classes['u-' + x + props[x]] = true;
		}

		if (props[x] === 'full') {
			classes['u-' + x + 'Full'] = true;
		}

		if (x === 'u-sm-flexOrder' && (props[x] === 'None' || props[x] === 'First' || props[x] === 'Last')) {
			classes['' + x + props[x]] = true;
		}

		if (x === 'u-md-flexOrder' && (props[x] === 'None' || props[x] === 'First' || props[x] === 'Last')) {
			classes['' + x + props[x]] = true;
		}

		if (x === 'u-lg-flexOrder' && (props[x] === 'None' || props[x] === 'First' || props[x] === 'Last')) {
			classes['' + x + props[x]] = true;
		}
	});

	return classes;
};

var visibleInCurrentBreakpoint = function visibleInCurrentBreakpoint(props) {
	if (props.breakpoint === 'xsm' || props.breakpoint === 'sm') {
		var visibleOnMobile = props.size !== 'hidden';
		return visibleOnMobile;
	}

	if (props.breakpoint === 'md') {
		var visibleOnTablet = props['md-size'] !== 'hidden';
		return visibleOnTablet;
	}

	var visibleOnDesktop = props['lg-size'] !== 'hidden';
	return visibleOnDesktop;
};

var handleAnimateFinnished = function handleAnimateFinnished() {
	inViewportWatcher.dispose();
	inViewportWatcher = null;
};

var afterMount = function afterMount(_ref, el) {
	var props = _ref.props;
	var animation = props.animation,
	    duration = props.duration,
	    iterations = props.iterations;


	if (animation && animation !== 'none' && duration && iterations) {
		inViewportWatcher = (0, _actions.animate)(animation, duration, iterations, el, handleAnimateFinnished);
	}
};

var beforeUnmount = function beforeUnmount() {
	if (inViewportWatcher) {
		inViewportWatcher.dispose();
		inViewportWatcher = null;
	}
};

var render = function render(_ref2) {
	var props = _ref2.props;
	var children = props.children;


	if (!visibleInCurrentBreakpoint(props)) {
		return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('noscript', null), props);
	}

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': [getClasses(props), props.class] },
		children
	), props);
};

exports.default = { afterMount: afterMount, beforeUnmount: beforeUnmount, render: render };